import { render, staticRenderFns } from "./8DesignEstimate.vue?vue&type=template&id=d1aa0b18&"
import script from "./8DesignEstimate.vue?vue&type=script&lang=js&"
export * from "./8DesignEstimate.vue?vue&type=script&lang=js&"
import style0 from "./8DesignEstimate.vue?vue&type=style&index=0&id=d1aa0b18&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports